import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { initialRepAuthState, type SessionActionType } from '@/states/repAuthentication';

const authenticationSlice = createSlice({
  name: 'authentication',
  initialState: initialRepAuthState,
  reducers: {
    setLogin(state, action: PayloadAction<SessionActionType>) {
      state.isLogged = action.payload.isLogged;
      state.AccessToken = action.payload.AccessToken ?? state.AccessToken ?? '';
    },
    setAccessToken(state, action: PayloadAction<{ accessToken: string | null }>) {
      state.AccessToken = action.payload.accessToken || '';
    },
    resetSession: () => initialRepAuthState,
  },
  extraReducers: (builder) => {
    builder.addCase('RESET_AUTHENTICATION_STATE', () => initialRepAuthState);
  },
});

export const { setLogin, setAccessToken, resetSession } = authenticationSlice.actions;
export default authenticationSlice.reducer;
